<template>
  <div
    class="offcanvas offcanvas-end"
    tabindex="-1"
    id="offcanvasNavbar"
    aria-labelledby="offcanvasNavbarLabel"
  >
    <div class="offcanvas-body ms-canvasbody">
      <div
        v-if="isSignedIn"
        class="sign-in-container d-flex flex-column align-items-center justify-content-between"
      >
        <div class="d-flex flex-column align-items-center justify-content-between">
          <h3>Welcome, {{ userName }}</h3>

          <div class="text-center mt-what-is-nkt-text" v-if="showDoNotHaveAccess">
            <div>
              You have successfully signed in, but you currently do not have access to NKT
              MakeSense.
              <br />
              If you believe this is an error, please contact us for assistance.
            </div>
          </div>
        </div>
        <MsButton @click="logout">Sign Out</MsButton>
      </div>

      <div v-else class="d-flex flex-column align-items-center">
        <img src="@/assets/img/NKT MakeSense_Logo_for screen.png" class="logo-login" />

        <h3>Sign in</h3>
        <MsButton
          class="mt-signin-button"
          :button-type="ButtonStyles.PrimaryOrange"
          :button-size="ButtonSize.Standard"
          @click="login"
          >Sign in with NKT ID</MsButton
        >
        <MsButton class="mt-what-is-nkt-button" @click="showWhatIsNKT = !showWhatIsNKT"
          >What is NKT ID?</MsButton
        >

        <div class="text-center mt-what-is-nkt-text" v-if="showWhatIsNKT">
          <div>
            For your convenience, we use a Single Sign-On (SSO) system across all our platforms.
            This means you only need one account to access all our services.
          </div>
          <br />
          <div>
            When you click "Sign in" you'll be redirected to our secure company-wide login page to
            complete the process.
          </div>
          <br />
          <div>If you already have an account with us, simply use your existing credentials.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch, defineProps } from 'vue'
import { requiredInject } from '@/utilities/requiredInject'
import { MSAL } from '@/plugins/msal/msal'
import { useUserStore } from '@/stores/UserStore'
import { UserClient } from '@/server/MakeSenseApp-backend'
import MsButton from '@/components/general/buttons/MsButton.vue'
import { Offcanvas } from 'bootstrap'
import { ButtonStyles, ButtonSize } from '@/utilities/enums'

const userName = ref<string>()
const userStore = useUserStore()

const isSignedIn = ref(true)
const showWhatIsNKT = ref(false)
const showDoNotHaveAccess = ref(false)

const msal = requiredInject<MSAL>('MSAL')
const userClient = requiredInject<UserClient>('UserClient')

const props = defineProps({
  isLoggedIn: {
    type: Boolean
  }
})

onMounted(() => {
  watch(
    () => userStore.refreshDataCounter,
    () => {
      if (msal.isAuthenticated()) {
        userClient.currentUser().then((user) => {
          userStore.setCurrentUser(user)
          userName.value = user.name

          if (userStore.hasNoRoles) {
            showCanvas()
            showDoNotHaveAccess.value = true
          }
        })

        isSignedIn.value = true
      } else {
        isSignedIn.value = false
        showCanvas()
      }
    },
    { immediate: true }
  )
})

function showCanvas() {
  var element = document.getElementById('offcanvasNavbar')

  if (element) {
    const offcanvas = new Offcanvas(element, {
      backdrop: props.isLoggedIn == false ? 'static' : true,
      keyboard: props.isLoggedIn == false ? false : true
    })
    offcanvas.show()
  }
}

async function logout() {
  await msal.logout()
}

async function login() {
  await msal.login()
}
</script>

<style scoped>
.logo-login {
  width: 314px;
  margin-bottom: 48px;
}

.ms-canvasbody {
  margin-top: 124px;
  margin-bottom: 124px;
}

.offcanvas {
  width: 472px;
}

.mt-signin-button {
  margin-top: 72px;
}

.mt-what-is-nkt-button {
  margin-top: 16px;
}

.mt-what-is-nkt-text {
  text-align: center;
  margin-top: 16px;
  margin-right: 16px;
  margin-left: 16px;
}

.mt-do-not-have-access-text {
  text-align: center;
  margin-top: 16px;
  margin-right: 16px;
  margin-left: 16px;
}

.sign-in-container {
  height: 100%;
}

.ms-top-bar-not-logged-in {
  height: 0px;
}
</style>
